var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { staticClass: "pl-0 pr-0 pt-0 pb-0" },
    [
      _vm.loading
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: "spinner", size: "lg", spin: "" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-row",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.loading && _vm.hideNewField,
              expression: "!loading && hideNewField"
            }
          ]
        },
        [
          _c(
            "b-col",
            { staticClass: "text-left" },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    id: "customerGroupe",
                    breakpoint: "md",
                    label: "Customer",
                    "label-for": "customerselect",
                    horizontal: _vm.horizontal,
                    validated: ""
                  }
                },
                [
                  _c("b-form-select", {
                    staticClass: "mb-3",
                    attrs: {
                      options: _vm.customers,
                      id: "customerselect",
                      required: ""
                    },
                    on: {
                      input: function($event) {
                        _vm.selectionMade($event)
                      },
                      change: function($event) {
                        _vm.selectionMade($event)
                      }
                    },
                    model: {
                      value: _vm.selected_customer,
                      callback: function($$v) {
                        _vm.selected_customer = $$v
                      },
                      expression: "selected_customer"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.noNew && !_vm.selected_customer && _vm.hideNewField
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "text-left" },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary" },
                      on: {
                        click: function($event) {
                          _vm.addNew()
                        }
                      }
                    },
                    [_vm._v("Add New")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-row",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hideNewField === false,
              expression: "hideNewField === false"
            }
          ]
        },
        [
          _c(
            "b-col",
            { staticClass: "text-left" },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    id: "namegroup",
                    breakpoint: "md",
                    label: "Customer Name",
                    "label-for": "customername",
                    horizontal: _vm.horizontal,
                    validated: ""
                  }
                },
                [
                  _c("b-form-input", {
                    attrs: {
                      maxlength: "255",
                      placeholder: "New Customer Name",
                      required: ""
                    },
                    model: {
                      value: _vm.newCustomer.name,
                      callback: function($$v) {
                        _vm.$set(_vm.newCustomer, "name", $$v)
                      },
                      expression: "newCustomer.name"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hideNewField === false && _vm.newCustomer.name,
              expression: "hideNewField === false && newCustomer.name"
            }
          ]
        },
        [
          _c(
            "b-col",
            { staticClass: "text-left" },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    id: "industrygroup",
                    breakpoint: "md",
                    label: "Industry",
                    "label-for": "customerindustry",
                    horizontal: _vm.horizontal,
                    validated: ""
                  }
                },
                [
                  _c("b-form-select", {
                    staticClass: "mb-3",
                    attrs: {
                      options: _vm.industries,
                      id: "customerindustry",
                      required: ""
                    },
                    model: {
                      value: _vm.newCustomer.industry,
                      callback: function($$v) {
                        _vm.$set(_vm.newCustomer, "industry", $$v)
                      },
                      expression: "newCustomer.industry"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hideNewField === false && _vm.newCustomer.industry,
              expression: "hideNewField === false && newCustomer.industry"
            }
          ]
        },
        [
          _c(
            "b-col",
            { staticClass: "text-left" },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    id: "industry2group",
                    breakpoint: "md",
                    label: "Secondary Industry",
                    "label-for": "customerindustry2",
                    horizontal: _vm.horizontal,
                    validated: ""
                  }
                },
                [
                  _c("b-form-select", {
                    staticClass: "mb-3",
                    attrs: { options: _vm.industries, id: "customerindustry2" },
                    model: {
                      value: _vm.newCustomer.secondary_industry,
                      callback: function($$v) {
                        _vm.$set(_vm.newCustomer, "secondary_industry", $$v)
                      },
                      expression: "newCustomer.secondary_industry"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hideNewField === false && _vm.newCustomer.industry,
              expression: "hideNewField === false && newCustomer.industry"
            }
          ]
        },
        [
          _c(
            "b-col",
            { staticClass: "text-left" },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    id: "countrygroup",
                    breakpoint: "md",
                    label: "Country",
                    "label-for": "customercountry",
                    horizontal: _vm.horizontal,
                    validated: ""
                  }
                },
                [
                  _c("b-form-select", {
                    staticClass: "mb-3",
                    attrs: {
                      options: _vm.countries,
                      id: "customercountry",
                      required: ""
                    },
                    model: {
                      value: _vm.newCustomer.country,
                      callback: function($$v) {
                        _vm.$set(_vm.newCustomer, "country", $$v)
                      },
                      expression: "newCustomer.country"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hideNewField === false && _vm.newCustomer.country,
              expression: "hideNewField === false && newCustomer.country"
            }
          ]
        },
        [
          _c(
            "b-col",
            { staticClass: "text-left" },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    id: "regiongroup",
                    breakpoint: "md",
                    label: "Region",
                    "label-for": "customerregion",
                    horizontal: _vm.horizontal,
                    validated: ""
                  }
                },
                [
                  _c("b-form-select", {
                    staticClass: "mb-3",
                    attrs: { options: _vm.regions, id: "customerregion" },
                    model: {
                      value: _vm.newCustomer.region,
                      callback: function($$v) {
                        _vm.$set(_vm.newCustomer, "region", $$v)
                      },
                      expression: "newCustomer.region"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.hideNewField && !_vm.loading && !_vm.noNew,
              expression: "!hideNewField && !loading && !noNew"
            }
          ]
        },
        [
          _c(
            "b-col",
            { staticClass: "text-left" },
            [
              _c(
                "b-button",
                {
                  attrs: {
                    variant: "success",
                    disabled: !_vm.newCustomer.country
                  },
                  on: {
                    click: function($event) {
                      _vm.save()
                    }
                  }
                },
                [_vm._v("Save")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "text-right" },
            [
              _c(
                "b-button",
                {
                  attrs: { variant: "default" },
                  on: {
                    click: function($event) {
                      _vm.cancelAdd()
                    }
                  }
                },
                [_vm._v("Cancel")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2260c44e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2260c44e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CustomerSelection.vue
// module id = null
// module chunks = 